'use client'

import type { SearchTopFoundProductsProps } from '@maestro/commerce-blocks/components/search-bar/search.types'

import { useTranslations } from 'next-intl'
import React, { useCallback } from 'react'

import { ProductSlider } from '@maestro/commerce-blocks/components/product-slider'
import { useSearchTopFoundProducts } from '@maestro/commerce-blocks/components/search-bar/batons/use-search-top-found-products'
import { TrackingButton } from '@maestro/commerce-blocks/components/tracking-button'
import { theme } from '@maestro/local/theme'

import '@maestro/commerce-blocks/components/search-bar/styles/search-bar.scss'

const SearchTopFoundProducts = ({
  handleHideSearch,
  productsCount,
  searchResult,
}: SearchTopFoundProductsProps) => {
  const {
    addToCartDisplayType: { searchTopFoundProducts: addToCartType },
    displayPrice: { searchTopFoundProducts: isEnabledDisplayPrice },
    displayStockStatus: { searchTopFoundProducts: isEnabledDisplayStockStatus },
  } = theme().product
  const t = useTranslations('commerce-blocks')
  const { firstTop5Products, showAll } = useSearchTopFoundProducts({
    productsCount,
    searchResult,
  })

  const handleClickShowAll = useCallback(() => {
    handleHideSearch()
  }, [handleHideSearch])

  if (productsCount > 0) {
    return (
      <>
        <h5 className="searchbar__suggestions-title">
          {t('search.products')}
          <span className="searchbar__suggestions-title-counter">
            {'(' + productsCount + ')'}
          </span>
        </h5>
        {firstTop5Products && (
          <div className="searchbar__suggestions-carousel">
            <ProductSlider
              products={firstTop5Products}
              addToCartType={addToCartType}
              eventListProps={{
                listId: `search-${searchResult.indexName}`,
                listName: 'Search top found products',
                listType: 'search-top-found-products',
              }}
              displayStockStatus={isEnabledDisplayStockStatus}
              enableClientSideStockFetching={false}
              displayPrice={isEnabledDisplayPrice}
              enableClientSidePriceFetching={false}
              eventSearchProps={{
                searchIndex: searchResult.indexName,
                queryID: searchResult?.queryID,
              }}
            />
          </div>
        )}
        <TrackingButton
          location="Search Dropdown"
          clickUrl={`/search/?text=${searchResult.query.text}`}
          onClick={handleClickShowAll}
          className="searchbar__suggestions-button--all"
          iconRight="arrow-right"
          type="primary"
        >
          {showAll}
        </TrackingButton>
      </>
    )
  }

  return null
}

export default SearchTopFoundProducts
